import React from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { Button, Icon, List, Modal, Segment } from "semantic-ui-react";
import { TreatmentPrescriptionDto } from "ts-types/api.types";
import styled from "styled-components";
import PraxFormScrollableContainer from 'components/layout/PraxFormScrollableContainer';
import { getTreatmentPrescriptionUrl } from 'services/treatmentPrescriptionServices';

const StyledModal = styled(Modal)`
  height: 90vh;
  width: 90vw !important;
`;

const StyledModalContent = styled(Modal.Content)`
  padding: 0 !important;
  height: 100% !important;
`;

const StyledSegmentGroup = styled(Segment.Group)`
  margin: 0 !important;
  height: 100% !important;
  border: none !important;
`;

const LeftSegment = styled(Segment)`
  width: 70% !important;
  padding: 0 !important;
`;

const RightSegment = styled(Segment.Group)`
  width: 30% !important;
  margin: 0 !important;
  border: none !important;
`;

const ListSegment = styled(Segment)`
  padding: 0 !important;
  height: 100% !important;
`;

const ButtonSegment = styled(Segment)`
  height: 8% !important;
  min-height: 50px !important;
  padding-top: 7% !important;
  padding-bottom: 6% !important;
  align-items: center;

  & button {
    float: right;
  }
`;

const ListContent = styled.div`
  width: 90%;
  display: inline-block;
  align-items: center;
`;

const DownloadSection = styled.div`
  width: 10%;
  display: inline-block;
  align-items: center;
  vertical-align: top;
`;

const StyledListItem = styled(List.Item)`
  padding: 0.75rem !important;
`;

const btnStyle = {
  background: "transparent",
  cursor: "pointer",
  padding: "5px 10px"
};

interface Props extends MessageSourceProps {
  treatmentPrescription: TreatmentPrescriptionDto,
  treatmentDownloadKey: string,
  modalOpen: boolean,
  onCloseModal: () => void
}

const TreatmentPrescriptionPreviewModal = (props: Props) => {

  const {
    treatmentPrescription,
    treatmentDownloadKey,
    modalOpen,
    onCloseModal,
    getMessage
  } = props;

  const treatmentPrescriptionUrl: string = getTreatmentPrescriptionUrl(treatmentDownloadKey);

  const treatmentPrescriptionMenu = (
      <StyledListItem
          active={true}
      >
        <List.Icon style={{padding: "10px"}} name="file pdf outline" size="large" verticalAlign="middle"/>
        <List.Content>
          <ListContent>
            <List.Header as="h4">{treatmentPrescription.fileName}</List.Header>
            <List.Description as="span">{treatmentPrescription.fileType}</List.Description>
          </ListContent>
          <DownloadSection>
            <Button
                as="a"
                href={treatmentPrescriptionUrl}
                download={treatmentPrescription.fileName}
                icon
                style={btnStyle}
            >
              <Icon name="download" size="large"/>
            </Button>
          </DownloadSection>
        </List.Content>
      </StyledListItem>
  );

  return (
      <StyledModal
          open={modalOpen}
          onClose={onCloseModal}
      >
        <StyledModalContent>
          <StyledSegmentGroup horizontal>
            <LeftSegment>
              <embed
                  src={treatmentPrescriptionUrl}
                  width="100%"
                  height="100%"
              />
            </LeftSegment>
            <RightSegment>
              <PraxFormScrollableContainer height={"92%"}>
                <ListSegment>
                  <List divided relaxed selection>
                    {treatmentPrescriptionMenu}
                  </List>
                </ListSegment>
              </PraxFormScrollableContainer>
              <ButtonSegment>
                <Button compact
                        type="button"
                        onClick={onCloseModal}
                >
                  {getMessage("button.close")}
                </Button>
              </ButtonSegment>
            </RightSegment>
          </StyledSegmentGroup>
        </StyledModalContent>
      </StyledModal>
  );
};

export default withMessages(TreatmentPrescriptionPreviewModal);
